import type { NavItem } from '@/types/Navigation'

export const serialsNavigationMain:NavItem[] = [
    {
        key: 'serial',
        name: 'Основное'
    },
    {
        key: 'serial-seasons',
        name: 'Сезоны'
    },
    {
        key: 'serial-series',
        name: 'Серии'
    }
]

export const serieNavMenu:NavItem[] = [
    {
        key: 'list-series',
        name: 'Список серий'
    },
    {
        key: 'order',
        name: 'Порядок серий'
    },
    {
        key: 'voiceover-order',
        name: 'Порядок озвучек'
    },
]

export const seriesNavBottom:NavItem[] = [
    {
        key: 'list-series',
        name: 'Список серий'
    },
    {
        key: 'order',
        name: 'Порядок серий'
    },
]

export const seriesNavMenuRight:NavItem[] = [
    {
        key: 'create-serie',
        name: 'Добавить серию'
    },
    {
        key: 'massAddition',
        name: 'Массовое добавление серий'
    }
]